// Fragment "site content errors" — the refusal of a retired site-content key
// (lib/apiErrors.js CONTENT_KEY_RETIRED_CODE). Merged in ./index.js.
export default {
  fr: {
    "errors.contentKeyRetired": "Cette page n'est plus à jour : ce texte n'est plus utilisé par votre site. Rechargez la page et modifiez-le à nouveau.",
  },
  en: {
    "errors.contentKeyRetired": "This page is out of date: this text is no longer used by your site. Reload the page and edit it again.",
  },
  es: {
    "errors.contentKeyRetired": "Esta página no está actualizada: tu sitio ya no usa este texto. Recarga la página y vuelve a editarlo.",
  },
};
